<small class="debug">{{ me }}</small>
<br/>
<form novalidate autocomplete="off" class="inner5" [formGroup]="m_contGroup">
    <div class="wrap2">
        <div [style.grid-area]="'l1'">
            <button mat-raised-button (click)="dialogFontPreview()">
                <mat-icon style="font-size: 1.7em">font_download</mat-icon>
                {{ 'general.font' | transloco }}
            </button>
        </div>
        <div [style.grid-area]="'l2'">
            <a mat-raised-button (click)="eyeDropper()">
                <mat-icon class="addIcons">colorize</mat-icon>
                {{ 'general.pick' | transloco }}
            </a>
        </div>
        <div [style.grid-area]="'l3'">
            <input #ignoredInput class="colorFontBox" (click)="toggle=!toggle"
                   [style.background]="selectedFontColor"
                   [value]="selectedFontColor"
                   (colorPickerChange)="onColorChanged()"
                   [cpPosition]="'bottom'"
                   [cpIgnoredElements]="[ignoredInput]"
                   [readonly]="true"
                   [(cpToggle)]="toggle"
                   [(colorPicker)]="selectedFontColor"/>
        </div>
    </div>
    <mat-form-field style="margin-top: 10px;">
        <mat-label>{{ 'placeholder.fontName' | transloco }}</mat-label>
        <input matInput type="text" name="fontFamily"
               placeholder="{{'placeholder.fontName' | transloco}}"
               formControlName="fontFamily"
               [matAutocomplete]="auto"
               (blur)="checkFontFamily()"
               autocomplete="off">
        <a matSuffix aria-label="Clear" (click)="clearFontFamily()">
            <mat-icon>close</mat-icon>
        </a>
        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="selectedFontFamily($event)" (opened)="focusDropdown()">
            <cdk-virtual-scroll-viewport [itemSize]="15" class="font-dropdown" #viewport>
                <mat-option [value]="font" *cdkVirtualFor="let font of m_filteredFonts | async">
                    {{ font }}
                </mat-option>
            </cdk-virtual-scroll-viewport>
            <!-- <mat-option *ngFor="let font of m_filteredFonts | async" [value]="font">
            {{font}}
          </mat-option> -->
        </mat-autocomplete>
    </mat-form-field>

    <!-- disabled style selection 1-11-2022 -->
    <!--  <mat-form-field *ngIf="m_styles.length > 0" style="width: 200px;">-->
    <!--  <mat-form-field style="width: 200px;">-->
    <!--    <mat-select formControlName="fontStyle" placeholder="{{'placeholder.fontStyle' | transloco}}">-->
    <!--      <mat-option value="style" *ngFor="let style of m_styles">-->
    <!--        {{style}}-->
    <!--      </mat-option>-->
    <!--    </mat-select>-->
    <!--  </mat-form-field>-->


    <mat-form-field style="width: 200px;">
        <mat-label>{{ 'placeholder.fontSize' | transloco }}</mat-label>
        <input inputrestriction="numbers" formControlName="fontSize" min="0" max="999" type="number" matInput (change)="onChangeDebounced($event)"
               placeholder="">
    </mat-form-field>
    <br/>
    <br/>
    @if (!m_hideAlignment) {
        <div>
            <div style="width: 200px; margin: auto; text-align: left;">
                @if (experienceLevel > experienceLevelType.BEGINNER) {
                    <mat-checkbox formControlName="autoScaling" (change)="changeCheckbox($event)"> scale</mat-checkbox>
                    <br/>
                }
                <!--    <mat-checkbox formControlName="textDecoration" (change)="changeCheckbox($event)"> underline</mat-checkbox>-->
                <br/>
                <mat-checkbox formControlName="wrap" (change)="changeCheckbox($event)"> wrap</mat-checkbox>&nbsp;
            </div>
            <br/>
            <!-- <mat-label>{{'general.horizontalAlign' | transloco}}</mat-label> -->
            <br/>
            <br/>
            <mat-button-toggle-group [value]="justificationValue" (change)="onJustificationValueChange(fontJustification.value)"
                                     #fontJustification="matButtonToggleGroup">
                <mat-button-toggle value="left">
                    <mat-icon>format_align_left</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="center">
                    <mat-icon>format_align_center</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="right">
                    <mat-icon>format_align_right</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="justify">
                    <mat-icon>format_align_justify</mat-icon>
                </mat-button-toggle>
            </mat-button-toggle-group>
            <br/>
            <br/>
            @if (fontGroup.wrap && !m_hideVerticalAlignment) {
                <mat-label>{{ 'general.verticalAlign' | transloco }}</mat-label>
            }
            <br/>
            <br/>
            @if (!m_hideVerticalAlignment) {
                <div>
                    <mat-button-toggle-group [value]="justificationVerticalValue" (change)="onVerticalJustificationValueChange(fontVerticalJustification.value)"
                                             #fontVerticalJustification="matButtonToggleGroup">
                        <mat-button-toggle value="start">
                            <mat-icon>align_vertical_top</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle value="center">
                            <mat-icon>vertical_distribute</mat-icon>
                        </mat-button-toggle>
                        <mat-button-toggle value="end">
                            <mat-icon>align_vertical_bottom</mat-icon>
                        </mat-button-toggle>
                    </mat-button-toggle-group>
                </div>
            }
        </div>
    }
    @if (m_showOnlyVertical) {
        <div>
            <mat-button-toggle-group [value]="justificationVerticalValue" (change)="onVerticalJustificationValueChange(fontVerticalJustification.value)"
                                     #fontVerticalJustification="matButtonToggleGroup">
                <mat-button-toggle value="start">
                    <mat-icon>align_vertical_top</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="center">
                    <mat-icon>vertical_distribute</mat-icon>
                </mat-button-toggle>
                <mat-button-toggle value="end">
                    <mat-icon>align_vertical_bottom</mat-icon>
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    }
    <br/>
</form>


